// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9c92ff38","667":"b6c6f915"}[chunkId] + ".chunk.js";
};